import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: 100%;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @media (min-width: 768px) {
    min-height: 500px;
  }

  @media (min-width: 992px) {
    min-height: 600px;
  }
`;

export const ImageWrapper = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const ContentWrapper = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  padding: 2rem 1rem;
  min-height: 400px;
  gap: 1.5rem;

  @media (min-width: 768px) {
    padding: 3rem 2rem;
    min-height: 500px;
    gap: 2rem;
  }

  @media (min-width: 992px) {
    padding: 4rem 3rem;
    min-height: 600px;
    gap: 2.5rem;
    max-width: 1200px;
    margin: 0 auto;
    width: 100%;
  }
`;

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;

  @media (min-width: 768px) {
    margin-bottom: 1.5rem;
  }

  @media (min-width: 992px) {
    margin-bottom: 2rem;
  }
`;

export const TextBlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-width: 100%;

  @media (min-width: 768px) {
    max-width: 600px;
    gap: 1.5rem;
  }

  @media (min-width: 992px) {
    max-width: 700px;
    gap: 2rem;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;

  @media (min-width: 576px) {
    flex-direction: row;
    width: auto;
    gap: 1.5rem;
  }

  @media (min-width: 992px) {
    gap: 2rem;
  }
`;

export const PhotoCaptionWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: auto;
  padding-top: 1rem;

  @media (min-width: 768px) {
    padding-top: 1.5rem;
  }

  @media (min-width: 992px) {
    padding-top: 2rem;
  }
`;
